module.exports = __webpack_public_path__ + "img/962.4dcfce2c.png";